module.exports = __webpack_public_path__ + "2760e26f4885108bab450ca830a0a34e.jpg";